<template>
  <div class="publicity-top">
    <div class="header-new">
      <span class="tel">010-88484118-815</span>
      <span class="index"><a href="http://www.cebpubservice.com/">返回首页</a></span>
    </div>
    <div id="navbar">
      <div class="logo-new w1000">
        <div class="logo-img">
          <img src="../assets/images/logo.png" alt="">
          <span>行业公示</span>
        </div>
        <div class="nav" id="nav-box">
          <div class="nav-item">
            <a href="https://publicity.cebpubservice.com/publicity/SmartSupplyChain.html">数智供应链</a>
          </div>
          <div class="nav-item nav-active">
            <a href="#" class="nav-active" @click.prevent="goToGreenSupplyChain">绿色供应链</a>
          </div>
          <div class="nav-item">
            <a href="https://publicity.cebpubservice.com/publicity/talent/index.html">行业人才</a>
          </div>
          <div class="nav-item">
            <a href="https://publicity.cebpubservice.com/publicity/index.html">行业数据</a>
          </div>
          <div class="nav-item">
            <a href="https://publicity.cebpubservice.com/publicity/Introduction.html">栏目简介</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    goToGreenSupplyChain() {
      this.$router.push('/')
    }
  }
}
</script>

<style src="@/styles/publicity-navbar.css"></style>
